/*
        SUMMARY
            0 - Imports
            1 - Const / Variables
            2 - Functions
*/

/*---------------------/ 0 - Imports /-------------------*/
import HorizontalSliderLogos from '../components/horizontalSliderLogos';
require('./home-mobile/modules/contato-dropdown');
document.addEventListener('DOMContentLoaded', () => window.HomeContatoDropdown?.init());

/*---------------------/ 1 - Const - Variables /-------------------*/
// Variáveis serão gerenciadas pelo componente

/*---------------------/ 2 - Functions /-------------------*/

gsap.registerPlugin(ScrollTrigger);

const reveals = document.querySelectorAll('.reveal-up');
reveals.forEach((el, i) => {
    gsap.fromTo(el,
    { opacity: 0, y: 30 },
    {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none"
        },
        delay: i % 3 * 0.1,
        onComplete: () => {
        if (el.classList.contains('article-sidebar')) {
            gsap.set(el, { clearProps: "transform" });
        }
        }
    }
    );
});

// Parallax Cover
gsap.to(".cover-image", {
    y: "20%",
    ease: "none",
    scrollTrigger: {
    trigger: ".cover-container",
    start: "top bottom",
    end: "bottom top",
    scrub: true
    }
});

// ═══════ COPY TO CLIPBOARD (code blocks) ═══════
const copyBtn = document.querySelector('.copy-btn');
if (copyBtn) {
    copyBtn.addEventListener('click', function () {
    const code = this.nextElementSibling.innerText;
    navigator.clipboard.writeText(code).then(() => {
        this.innerText = 'Copiado!';
        setTimeout(() => this.innerText = 'Copiar', 2000);
    });
    });
}

// ═══════ SHARE COPY LINK ═══════
const shareCopyBtn = document.getElementById('shareCopyLink');
if (shareCopyBtn) {
    shareCopyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(() => {
            this.classList.add('is-copied');
            this.innerHTML = '<i class="fas fa-check"></i>';
            setTimeout(() => {
                this.classList.remove('is-copied');
                this.innerHTML = '<i class="fas fa-link"></i>';
            }, 2000);
        }).catch(() => {
            const ta = document.createElement('textarea');
            ta.value = window.location.href;
            ta.style.cssText = 'position:fixed;opacity:0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            this.classList.add('is-copied');
            this.innerHTML = '<i class="fas fa-check"></i>';
            setTimeout(() => {
                this.classList.remove('is-copied');
                this.innerHTML = '<i class="fas fa-link"></i>';
            }, 2000);
        });
    });
}

// Move elementos que excedem a altura máxima do .content-text para as colunas
// function splitOverflowContent() {
//     const source = document.querySelector('[data-overflow-split]');
//     if (!source) return;

//     const maxHeight = parseInt(source.dataset.overflowMax, 10) || 500;
//     const left = document.querySelector('[data-overflow-target="left"]');
//     const right = document.querySelector('[data-overflow-target="right"]');
//     if (!left || !right) return;

//     const sourceTop = source.getBoundingClientRect().top;
//     const children = Array.from(source.children);
//     const overflow = [];

//     for (const child of children) {
//         const rect = child.getBoundingClientRect();
//         const bottomRelative = (rect.bottom - sourceTop);
//         if (bottomRelative > maxHeight) {
//             overflow.push(child);
//         }
//     }

//     if (overflow.length === 0) return;

//     const half = Math.ceil(overflow.length / 2);
//     overflow.slice(0, half).forEach((el) => left.appendChild(el));
//     overflow.slice(half).forEach((el) => right.appendChild(el));
// }

// // Inicializa o slider de blog
// function initBlogSlider() {
//     // Aguarda os dados estarem disponíveis
//     const checkData = setInterval(() => {
//         if (typeof window.blogSliderData !== 'undefined' && window.blogSliderData.length > 0) {
//             clearInterval(checkData);
            
//             // Inicializa o slider horizontal
//             if (typeof HorizontalSliderLogos !== 'undefined') {
//                 HorizontalSliderLogos(window.blogSliderData);
//             } else if (typeof window.HorizontalSliderLogos !== 'undefined') {
//                 window.HorizontalSliderLogos.initializeSlider(window.blogSliderData);
//             }
//         }
//     }, 100);

//     // Timeout de segurança
//     setTimeout(() => {
//         clearInterval(checkData);
//         if (typeof window.blogSliderData === 'undefined') {
//             console.warn('⚠️ Blog slider data not found');
//         }
//     }, 5000);
// }

// Inicializa todos os componentes
function initAll() {
    splitOverflowContent();
    initBlogSlider();
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}

// Reinicializa se a página for carregada via AJAX
window.addEventListener('load', () => {
    setTimeout(initAll, 500);
});
